const cartData = [
    {
        id: 1,
        image: 'assets/images/product/img-1.png',
        name: 'Half sleeve T-shirt',
        color: 'Maroon',
        price: 450,
        qty: 2,
        total: '900'
    },
    {
        id: 2,
        image: 'assets/images/product/img-2.png',
        name: 'Light blue T-shirt',
        color: 'Light blue',
        price: 225,
        qty: 1,
        total: '225'
    },
    {
        id: 3,
        image: 'assets/images/product/img-3.png',
        name: 'Black Color T-shirt',
        color: 'Black',
        price: 152,
        qty: 1,
        total: '304'
    },
    {
        id: 4,
        image: 'assets/images/product/img-4.png',
        name: 'Hoodie (Blue)',
        color: 'Blue',
        price: 145,
        qty: 2,
        total: '290'
    },
    {
        id: 5,
        image: 'assets/images/product/img-5.png',
        name: 'Half sleeve T-Shirt',
        color: 'Light orange',
        price: 138,
        qty: 1,
        total: '138'
    },
    {
        id: 6,
        image: 'assets/images/product/img-6.png',
        name: 'Green color T-shirt',
        color: 'Green',
        price: 152,
        qty: 2,
        total: '304'
    }
];

export { cartData };
